import RecommendedItem from "./contracts/RecommendedItem";

/* eslint-disable import/prefer-default-export */
const pageSize = 4;

export const initItemPage = (items: RecommendedItem[]) => ({
  page: 1,
  items: items.slice(0, pageSize),
});

export const nextPage = (items: RecommendedItem[], page: number) =>
  new Promise<{ page: number; items: RecommendedItem[] }>((resolve) => {
    const start = page * pageSize - pageSize;

    if (page < 1 || start >= items.length) return resolve(initItemPage(items));

    return resolve({
      page,
      items: items.slice(start, start + pageSize),
    });
  });
